import { useMemo } from "react";
import Token from "src/util/Token";
import { COMPANY_TYPE } from "src/util/enums";

/**
 * True only when the logged-in user authenticated with a Grand Parent (GP)
 * company. The companyType is carried in the JWT issued at login, so this is
 * independent of which team is currently selected in the sidebar.
 *
 * Use to gate super-admin-only features (API Keys, Audit Logs).
 */
export const useIsGrandParent = () => {
  return useMemo(() => {
    const parsed = Token.parsedToken();
    return parsed.success && parsed.data?.companyType === COMPANY_TYPE.GRAND_PARENT;
  }, []);
};

export default useIsGrandParent;
